module.exports = __webpack_public_path__ + "assets/ebc53b1d917bdba495064ca1429bd0e0.png";